export const timeZoneAbbrvMap = [
  { abbr: 'GMT', name: 'Greenwich Mean Time (UTC + 0)', offset: '+00:00' },
  { abbr: 'CET', name: 'Central European Time (UTC + 1)', offset: '+01:00' },
  {
    abbr: 'AEST',
    name: 'Australian Eastern Standard Time (UTC + 10)',
    offset: '+10:00',
  },
  { abbr: 'NFT', name: 'Norfolk Time (UTC + 11)', offset: '+11:00' },
  {
    abbr: 'NZST',
    name: 'New Zealand Standard Time (UTC + 12)',
    offset: '+12:00',
  },
  {
    abbr: 'CHAST',
    name: 'Chatham Island Standard Time (UTC + 12:45)',
    offset: '+12:45',
  },
  { abbr: 'TOT', name: 'Tonga Time (UTC + 13)', offset: '+13:00' },
  { abbr: 'CAT', name: 'Central Africa Time (UTC + 2)', offset: '+02:00' },
  { abbr: 'EET', name: 'Eastern European Time (UTC + 2)', offset: '+02:00' },
  { abbr: 'IST', name: 'Israel Standard Time (UTC + 2)', offset: '+02:00' },
  {
    abbr: 'SAST',
    name: 'South Africa Standard Time (UTC + 2)',
    offset: '+02:00',
  },
  { abbr: 'AST', name: 'Arabia Standard Time (UTC + 3)', offset: '+03:00' },
  { abbr: 'EAT', name: 'Eastern Africa Time (UTC + 3)', offset: '+03:00' },
  { abbr: 'MSK', name: 'Moscow Standard Time (UTC + 3)', offset: '+03:00' },
  { abbr: 'TRT', name: 'Turkey Time (UTC + 3)', offset: '+03:00' },
  { abbr: 'IRST', name: 'Iran Standard Time (UTC + 3:30)', offset: '+03:30' },
  { abbr: 'AMT', name: 'Armenia Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'AZT', name: 'Azerbaijan Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'GET', name: 'Georgia Standard Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'GST', name: 'Gulf Standard Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'KUYT', name: 'Kuybyshev Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'MUT', name: 'Mauritius Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'RET', name: 'Reunion Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'SAMT', name: 'Samara Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'SCT', name: 'Seychelles Time (UTC + 4)', offset: '+04:00' },
  { abbr: 'AFT', name: 'Afghanistan Time (UTC + 4:30)', offset: '+04:30' },
  { abbr: 'MVT', name: 'Maldives Time (UTC + 5)', offset: '+05:00' },
  { abbr: 'PKT', name: 'Pakistan Standard Time (UTC + 5)', offset: '+05:00' },
  { abbr: 'TJT', name: 'Tajikistan Time (UTC + 5)', offset: '+05:00' },
  { abbr: 'TMT', name: 'Turkmenistan Time (UTC + 5)', offset: '+05:00' },
  { abbr: 'UZT', name: 'Uzbezkistan Time (UTC + 5)', offset: '+05:00' },
  { abbr: 'YEKT', name: 'Yekaterinburg Time (UTC + 5)', offset: '+05:00' },
  { abbr: 'IST', name: 'India Standard Time (UTC + 5:30)', offset: '+05:30' },
  { abbr: 'NPT', name: 'Nepal Time (UTC + 5:45)', offset: '+05:45' },
  {
    abbr: 'BST',
    name: 'Bangladesh Standard Time (UTC + 6)',
    offset: '+06:00',
  },
  { abbr: 'BTT', name: 'Bhutan Time (UTC + 6)', offset: '+06:00' },
  { abbr: 'IOT', name: 'Indian Chagos Time (UTC + 6)', offset: '+06:00' },
  { abbr: 'KGT', name: 'Kyrgyzstan Time (UTC + 6)', offset: '+06:00' },
  { abbr: 'VOST', name: 'Vostok Time (UTC + 6)', offset: '+06:00' },
  { abbr: 'MMT', name: 'Myanmar Time (UTC + 6:30)', offset: '+06:30' },
  {
    abbr: 'WIB',
    name: 'Western Indonesian Time (UTC + 7)',
    offset: '+07:00',
  },
  {
    abbr: 'AWST',
    name: 'Australian Western Standard Time (UTC + 8)',
    offset: '+08:00',
  },
  { abbr: 'BNT', name: 'Brunei Darussalam Time (UTC + 8)', offset: '+08:00' },
  { abbr: 'CST', name: 'China Standard Time (UTC + 8)', offset: '+08:00' },
  { abbr: 'HKT', name: 'Hong Kong Time (UTC + 8)', offset: '+08:00' },
  { abbr: 'MYT', name: 'Malaysia Time (UTC + 8)', offset: '+08:00' },
  { abbr: 'PHT', name: 'Philippine Time (UTC + 8)', offset: '+08:00' },
  { abbr: 'SGT', name: 'Singapore Time (UTC + 8)', offset: '+08:00' },
  {
    abbr: 'WITA',
    name: 'Central Indonesian Time (UTC + 8)',
    offset: '+08:00',
  },
  { abbr: 'PYT', name: 'Pyongyang Time (UTC + 8:30)', offset: '+08:30' },
  { abbr: 'JST', name: 'Japan Standard Time (UTC + 9)', offset: '+09:00' },
  { abbr: 'KST', name: 'Korea Standard Time (UTC + 9)', offset: '+09:00' },
  { abbr: 'TLT', name: 'East Timor Time (UTC + 9)', offset: '+09:00' },
  {
    abbr: 'WIT',
    name: 'Eastern Indonesian Time (UTC + 9)',
    offset: '+09:00',
  },
  {
    abbr: 'ACST',
    name: 'Australian Central Standard Time (UTC + 9:30)',
    offset: '+09:30',
  },
  { abbr: 'EGT', name: 'East Greenland Time (UTC - 1)', offset: '-01:00' },
  { abbr: 'HST', name: 'Hawaii Standard Time (UTC - 10)', offset: '-10:00' },
  { abbr: 'TAHT', name: 'Tahiti Time (UTC - 10)', offset: '-10:00' },
  { abbr: 'SST', name: 'Samoa Standard Time (UTC - 11)', offset: '-11:00' },
  { abbr: 'AoE', name: 'Anywhere on Earth (UTC - 12)', offset: '-12:00' },
  { abbr: 'GST', name: 'South Georgia Time (UTC - 2)', offset: '-02:00' },
  { abbr: 'ART', name: 'Argentina Time (UTC - 3)', offset: '-03:00' },
  { abbr: 'BRT', name: 'Brasilia Time (UTC - 3)', offset: '-03:00' },
  { abbr: 'GFT', name: 'French Guiana Time (UTC - 3)', offset: '-03:00' },
  { abbr: 'SRT', name: 'Suriname Time (UTC - 3)', offset: '-03:00' },
  { abbr: 'UYT', name: 'Uruguay Time (UTC - 3)', offset: '-03:00' },
  {
    abbr: 'NST',
    name: 'Newfoundland Standard Time (UTC - 3:30)',
    offset: '-03:30',
  },
  { abbr: 'AMT', name: 'Amazon Time (UTC - 4)', offset: '-04:00' },
  { abbr: 'BOT', name: 'Bolivia Time (UTC - 4)', offset: '-04:00' },
  { abbr: 'CLT', name: 'Chile Standard Time (UTC - 4)', offset: '-04:00' },
  { abbr: 'PYT', name: 'Paraguay Time (UTC - 4)', offset: '-04:00' },
  {
    abbr: 'VET',
    name: 'Venezuelan Standard Time (UTC - 4)',
    offset: '-04:00',
  },
  {
    abbr: 'CIST',
    name: 'Cayman Islands Standard Time (UTC - 5)',
    offset: '-05:00',
  },
  { abbr: 'COT', name: 'Colombia Time (UTC - 5)', offset: '-05:00' },
  { abbr: 'CST', name: 'Cuba Standard Time (UTC - 5)', offset: '-05:00' },
  { abbr: 'ECT', name: 'Ecuador Time (UTC - 5)', offset: '-05:00' },
  { abbr: 'EST', name: 'Eastern Standard Time (UTC - 5)', offset: '-05:00' },
  { abbr: 'PET', name: 'Peru Time (UTC - 5)', offset: '-05:00' },
  { abbr: 'CST', name: 'Central Standard Time (UTC - 6)', offset: '-06:00' },
  { abbr: 'GALT', name: 'Galapagos Time (UTC - 6)', offset: '-06:00' },
  { abbr: 'MST', name: 'Mountain Standard Time (UTC - 7)', offset: '-07:00' },
  { abbr: 'PST', name: 'Pacific Standard Time (UTC - 8)', offset: '-08:00' },
  { abbr: 'AKST', name: 'Alaska Standard Time (UTC - 9)', offset: '-09:00' },
  { abbr: 'GAMT', name: 'Gambier Time (UTC - 9)', offset: '-09:00' },
];
